import { render, staticRenderFns } from "./CameraConfig.vue?vue&type=template&id=766be1d2&scoped=true"
import script from "./CameraConfig.vue?vue&type=script&lang=js"
export * from "./CameraConfig.vue?vue&type=script&lang=js"
import style0 from "./CameraConfig.vue?vue&type=style&index=0&id=766be1d2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766be1d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('766be1d2')) {
      api.createRecord('766be1d2', component.options)
    } else {
      api.reload('766be1d2', component.options)
    }
    module.hot.accept("./CameraConfig.vue?vue&type=template&id=766be1d2&scoped=true", function () {
      api.rerender('766be1d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/camera/CameraConfig.vue"
export default component.exports